import { PersonalizedCardOrder } from '../personalized-card-order';

export class TextGenerator {

  static MARKERS = {
    'quantity': '#QUANTITY#',
    'print_finish': '#PRINT_FINISH#',
    'shipping_details': '#SHIPPING_DETAILS#',
    'comment': '#COMMENT#'
  };

  static UNITED_PRODUCTS_TEMPLATE =
    'Hi zusammen,<br><br>' +
    'wir würden gerne eine neue Bestellung in Auftrag geben.<br><br>' +
    `${TextGenerator.MARKERS.comment}` +
    'Anzahl:<br>' +
    `<strong>${TextGenerator.MARKERS.quantity} Stück, ${TextGenerator.MARKERS.print_finish}</strong><br><br>` +
    'Versand an:<br><br>' +
    `<strong>${TextGenerator.MARKERS.shipping_details}</strong><br><br>` +
    'Links zu den Druckdateien befinden sich am Ende der E-Mail, die QR-Code-Datei ist im Anhang.<br><br>' +
    'Viele Grüße<br>' +
    'Mankido Team';

  static WIR_MACHEN_DRUCK_TEMPLATE =
    'Liebes Wir-machen-Druck-Team,<br><br>' +
    'wir möchten gerne eine neue Bestellung aufgeben.<br><br>' +
    `${TextGenerator.MARKERS.comment}` +
    '<strong>Bestelldaten:</strong>' +
    '<ul>' +
    `<li>Lieferadresse:<br>${TextGenerator.MARKERS.shipping_details}</li>` +
    `<li>Auflage: ${TextGenerator.MARKERS.quantity} Stück</li>` +
    `<li>Material: ${TextGenerator.MARKERS.print_finish}</li>` +
    '</ul>' +
    'Die Vorderseite der Plastikkarte und die Liste der QR-Codes findet ihr anbei. ' +
    'Layout und Design der Rückseite bitte aus den hinterlegten Unterlagen verwenden.<br><br>' +
    'Bei Rückfragen können Sie sich jederzeit gerne bei uns melden.<br><br>' +
    'Beste Grüße<br><br>' +
    'Team Mankido';

  constructor() {
  }

  static generate(personalizedCardOrder: PersonalizedCardOrder, comment: string): string {
    const markers = [
      {marker: this.MARKERS.quantity, value: personalizedCardOrder.quantity ? personalizedCardOrder.quantity.toString() : ''},
      {marker: this.MARKERS.print_finish, value: personalizedCardOrder.print_finish},
      {marker: this.MARKERS.shipping_details, value: this.createShippingDetails(personalizedCardOrder)},
      {marker: this.MARKERS.comment, value: comment ? `${comment}<br><br>` : ''}
    ];
    const template = personalizedCardOrder.printer === 'wir_machen_druck'
      ? this.WIR_MACHEN_DRUCK_TEMPLATE
      : this.UNITED_PRODUCTS_TEMPLATE;
    return this.replaceMarker(template, markers);
  }

  private static replaceMarker(text: string, markers: { marker: string, value: string }[]) {
    markers.forEach(marker => {
      text = text.replace(marker.marker, marker.value);
    });
    return text;
  }

  private static createShippingDetails(order: PersonalizedCardOrder) {
    let shippingDetails = '';
    if (order.company_name) {
      shippingDetails += `${order.company_name || '[Firmenname]'}<br>`;
    }
    shippingDetails += `${order.contact_person || '[Kontaktperson]'}<br>` +
      `${order.address || '[Adresse]'}<br>` +
      `${order.zip || '[PLZ]'} ${order.city || '[Stadt]'}`;

    if (order.country) {
      shippingDetails += `<br>${order.country}`;
    }
    return shippingDetails;
  }
}
